import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { ExpandableScrollContainer } from '../../scroll-container/ExpandableScrollContainer';
import styles from './AccordionMenu.module.scss';

export const ExpandableAccordionMenu = ({
    children, active, className, initialHeight = 360
}: Props) => {

    if (!active) {
        return null;
    }

    const classes = classNames(className, styles.default);

    return (
        <ExpandableScrollContainer initialHeight={initialHeight} className={classes}>
            {children}
        </ExpandableScrollContainer>
    );
};

type Props = PropsWithChildren<{
    active: boolean;
    className?: string;
    initialHeight?: number;
}>;